import * as angular from "angular";

import { isSupportedOrNullish } from "../../../../../isSupportedOrNullish";
import { getEntityOverviewSchema } from "../../../../../entity-schema-state";
import {
	ENTITY_TRANSLATION_KEYS,
	I18NextContext
} from "../../../../../../../services/i18nService";
import {
	getEntityTimeZone,
	hasSystemKeyValues,
	mapEntityForForm
} from "../entityFormModel";
import entitySchemaValues from "../../entity-schema-tab/entity-schema-values/entity-schema-values";
import template from "./entity-form-viewer.html";
import "./entity-form-viewer.less";

export function controller(entityManager) {
	const ctrl = this;

	ctrl.i18n = I18NextContext.Instance;
	ctrl.ENTITY_TRANSLATION_KEYS = ENTITY_TRANSLATION_KEYS;
	ctrl.$onChanges = onChanges;
	ctrl.isSupportedOrNullish = isSupportedOrNullish;

	ctrl.$onInit = () => {
		syncEntity();
	};

	function onChanges(changes) {
		const entityChange = changes.entity;
		if(!entityChange || entityChange.isFirstChange()) {
			return;
		}

		syncEntity(entityChange.currentValue);
	}

	function syncEntity(entity = ctrl.entity) {
		ctrl.isNewEntity = entity === undefined;
		if(ctrl.isNewEntity) {
			ctrl.displayEntity = undefined;
			ctrl.timeZoneName = undefined;
			ctrl.hasSystemKeyValues = false;
			ctrl.overviewSchema = undefined;
			return;
		}

		ctrl.displayEntity = mapEntityForForm(entity, entityManager);
		ctrl.timeZoneName = getEntityTimeZone(ctrl.displayEntity.TimeZone?.Code)?.name;
		ctrl.hasSystemKeyValues = hasSystemKeyValues(ctrl.entityType, ctrl.displayEntity);

		ctrl.overviewSchema = getEntityOverviewSchema(ctrl.entityType.Schema);
	}
}

export default angular.module("vesl.components.entity-form-viewer", [entitySchemaValues])
	.component("entityFormViewer", {
		controller,
		template,
		bindings: {
			entity: "<",
			entityType: "<"
		}
	})
	.name;
